import { useEffect } from 'react';
import { FormField, Input } from '@amzn/awsui-components-react-v3';

interface ClassSizeInputProps {
    setClassSize: any;
    errors: any;
    classSize: number | null;
    /** When true, field is read-only and auto-calculated from customer commitments */
    isSemiPrivate?: boolean;
    /** Sum of customer number_of_students_committed (used when isSemiPrivate is true) */
    customerCommitmentsSum?: number;
}

const ClassSizeInput = ({
    setClassSize,
    errors,
    classSize,
    isSemiPrivate = false,
    customerCommitmentsSum = 0,
}: ClassSizeInputProps) => {
    // For semi-private activities, display the auto-calculated value
    const displayValue = isSemiPrivate ? customerCommitmentsSum : classSize;

    // Auto-sync class_size for semi-private activities when it differs from customer sum
    useEffect(() => {
        if (isSemiPrivate && classSize !== customerCommitmentsSum) {
            setClassSize({ class_size: customerCommitmentsSum });
        }
    }, [isSemiPrivate, customerCommitmentsSum, classSize, setClassSize]);

    return (
        <FormField
            data-testid="formField-class-input-size"
            label="Class size"
            errorText={errors?.class_size}
            description={
                isSemiPrivate
                    ? 'Auto-calculated from customer commitments'
                    : undefined
            }
        >
            <Input
                onChange={({ detail }) => {
                    if (isSemiPrivate) return; // Read-only for semi-private
                    const value =
                        detail.value === '' ? null : Number(detail.value);
                    setClassSize({ class_size: value });
                }}
                type="number"
                value={`${displayValue ?? ''}`}
                data-testid="class-size-input"
                disabled={isSemiPrivate}
            />
        </FormField>
    );
};

export default ClassSizeInput;
